<div class="reservacion-table">
	<div class="reservacion-table-header divisas-row">
		<h6 class="text-color-primary my-0 mx-3">{{ 'SHARED.TABLE_HISTORY_TITLE' | translate }}</h6>
	</div>
	<hr class="mt-0 pt-0">
	<div class="reservacion-table-body pb-2 mx-3 table-responsive-sm">
		<table class="">
			<thead>
				<tr>
					<th style="min-width: 130px;">{{ 'SHARED.TH_RESERVATION_DATE' | translate }}</th>
					<th style="min-width: 130px;">{{ 'SHARED.TH_AMOUNT_PAID' | translate }}</th>
					<th style="min-width: 130px;">{{ 'SHARED.TH_AMOUNT_RECEIVED' | translate }}</th>
					<th style="min-width: 130px;">{{ 'SHARED.TH_BRANCH' | translate }}</th>
					<th style="min-width: 130px;">{{ 'SHARED.TH_CAPITAL_POINTS' | translate }}</th>
					<th style="min-width: 130px;">{{ 'SHARED.TH_STATUS' | translate }}</th>
					<th style="min-width: 130px;"></th>
				</tr>
			</thead>
			<tbody>
				<tr class="mx-2" *ngFor="let reservacion of historyReservations">
					<td class="cuerpo-2">{{ reservacion.createdAt | date: 'dd/MM/yy'}}</td>
					<td class="cuerpo-2">{{ reservacion.transaction[0].amountPayment }} {{ reservacion.transaction[0].idCurrencyPayment.name }}</td>
					<td class="cuerpo-2">{{ reservacion.transaction[0].amountReceives }} {{ reservacion.transaction[0].idCurrencyReceives.name }}</td>
					<td class="cuerpo-2">{{ reservacion.idBranch.branchName }}</td>
					<td class="cuerpo-2">{{ reservacion.quotation?.calculatedPoints ?? 0 }} {{ 'RESERVATIONS_DETAILS.POINTS_ABBREV' | translate }}</td>
					<td class="cuerpo-2 text-danger" *ngIf="reservacion.stateOrder == 'cancel'">{{ 'SHARED.STATUS_CANCELLED_TABLE' | translate }}</td>
					<td class="cuerpo-2 text-success" *ngIf="reservacion.stateOrder == 'paid'">{{ 'RESERVATIONS_LIST.STATUS_SUCCESS' | translate }}</td>
					<td>
						<button class="btn btn-outline-light divisa-row" [routerLink]="[reservacion.id]">{{ 'RESERVATIONS_LIST.VIEW_DETAILS' | translate }}</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<!-- <hr> -->
	<!-- <div class="divisa-space-between pb-3 mx-3 mb-0">
		<div class="divisa-col-2">Filas por página 4</div>
		<div class="divisa-col-2">1-5 de 20 páginas </div>
	</div> -->
</div>
